/* eslint-disable max-len */
import { Accessory } from './accessory.class';
import { addSkuCfn } from './functions';
import { BlueprintInstanceType } from '../shared.enums';

import { AccessoriesDataIn, AccessoriesDataOut } from './types';
import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';

export class Accessories extends KitchenDesignBase<AccessoriesDataIn> {
	readonly children: Array<Accessory>;
	/**
	 * The constructor of the 'PanelItems' class
	 * @param options provides context, also used to hydrate the instance
	*/
	constructor (options: KitchenDesignOptions<AccessoriesDataIn> = {}) {
		super(BlueprintInstanceType.PromotionalSkus, options);

		const { dataIn: data = null } = options;

		this.children = [];
		if (data && data.children?.length > 0) {
			data.children?.forEach((n) => this.children.push(new Accessory({ dataIn: n, parent: this })));
		}

		this.setInitialized();
	}

	/**
	 * Get all children
	 *
	 */
	get totalSkus (): number { return this.children.length }

	get isValid (): boolean { return this.children.every((accessory) => accessory.isValid) }

	/**
	 * Creates and adds a new promotional sku and push the promotional-sku items in children
	 *
	 * @param sku sku of accessory item to add
	 * @returns Instance of accessory
	 */
	public newSku (sku: string): Accessory {
		const pSku = addSkuCfn(this, sku);
		// console.log('pSku', pSku);
		if (pSku) this.children.push(pSku);
		return pSku;
	}

	/**
	 *
	 * @param id id of accessory item to find
	 * @returns Accessory
	*/
	public findById (id: string): Accessory {
		return this.children.find((pi) => pi.id === id);
	}

	/**
	 *
	 * @param sku sku code of accessory item to find
	 * @returns Accessory
	*/
	public findBySku (sku: string): Accessory {
		return this.children.find((ps) => ps.sku === sku);
	}

	// serialize
	public serialize (): AccessoriesDataOut {
		return {
			children: this.children.map((child) => child.serialize()),
			_metadata: {
				totalSkus: this.totalSkus
			}
		};
	}
}
